import en_GB from "antd/lib/locale/en_GB";
import fr_FR from "antd/lib/locale/fr_FR";
import i18n from "config/i18n/i18n";

export const PROJECT_COLOR = "#3e849e";
export const SEARCH_LIMIT = 30;
export const DATE_FORMAT = "DD/MM/YYYY";
export const TIME_FORMAT = "HH:mm";
export const DATE_FORMAT_API = "YYYY-MM-DD";

const CONFIG_TRANSLATIONS = {
  fr: fr_FR,
  en: en_GB,
};

export const language =
  CONFIG_TRANSLATIONS[i18n.language as keyof typeof CONFIG_TRANSLATIONS]?.locale;
